export default {
  "betOrder.thead.userNo": "UserNo",
  "betOrder.thead.email": "Email",
  "betOrder.thead.gameName": "GameName",
  "betOrder.thead.gameType": "GameType",
  "betOrder.thead.betType": "BetType",
  "betOrder.thead.betAmount": "BetAmount",
  "betOrder.thead.validBet": "ValidBet",
  "betOrder.thead.resultAmount": "ResultAmount",
  "betOrder.thead.lossWinAmount": "LossWinAmount",
  "betOrder.thead.providerName": "ProviderName",
  "betOrder.thead.betTime": "BetTime",
  "betOrder.thead.resultTime": "ResultTime",
  "betOrder.thead.betFinish": "BetFinish",
  "betOrder.thead.isCancel": "IsCancel",
  "betOrder.thead.isCancel.yes": "yes",
  "betOrder.thead.isCancel.no": "no",
  "betOrder.thead.betOrderno": "BetOrderno",
  "betOrder.thead.merBetOrderno": "MerBetOrderno",
  "betOrder.title": "Bet Order",
};
